import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupMemberStateIndicatorComponent } from './group-member-state-indicator.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';



@NgModule({
    declarations: [
        GroupMemberStateIndicatorComponent
    ],
    imports: [
        CommonModule,
        SvgIconModule
    ],
    exports: [
        GroupMemberStateIndicatorComponent
    ]
})
export class GroupMemberStateIndicatorModule { }
